import React from 'react';
import styled from 'styled-components';
import { Alert, AlertTitle, Button, Link } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

// Styled components for the alert to match your design system
const StyledAlert = styled(Alert)`
  && {
    margin-bottom: 20px;
    border-radius: 4px;
    font-family: 'Roboto', sans-serif;
    display: flex;
    align-items: flex-start;
  }
`;

const StyledAlertTitle = styled(AlertTitle)`
  && {
    font-weight: 500;
    margin-bottom: 4px;
    font-family: 'Roboto', sans-serif;
  }
`;

const ActionButton = styled(Button)`
  && {
    margin-top: 8px;
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    background-color: ${props => props.theme.palette?.primary?.main || '#1976d2'};
    color: white;
    padding: 6px 16px;
    text-transform: none;
    
    &:hover {
      background-color: ${props => props.theme.palette?.primary?.dark || '#115293'};
    }
  }
`;

const ResendLink = styled(Link)`
  && {
    cursor: pointer;
    margin-left: 12px;
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    text-decoration: underline;
    color: ${props => props.theme.palette?.primary?.main || '#1976d2'};
    
    &:hover {
      color: ${props => props.theme.palette?.primary?.dark || '#115293'};
    }
  }
`;

const VerificationAlert = ({
    email,
    onVerifyClick,
    onResendCode,
    isPendingVerification = false
}) => {
    if (!isPendingVerification) return null;

    return (
        <StyledAlert
            severity="error"
            icon={<EmailIcon />}
            sx={{
                mb: 3,
                fontSize: '0.875rem'
            }}
        >
            <StyledAlertTitle>Account needs verification</StyledAlertTitle>
            Please check your inbox (including spam/junk folders) for the verification code sent to <strong>{email}</strong>.
            <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <ActionButton
                    size="small"
                    variant="contained"  // Changed from outlined to contained
                    color="primary"      // Changed from warning to primary for better contrast
                    onClick={onVerifyClick}
                    startIcon={<EmailIcon />}
                    sx={{
                        py: 0.7,           // Slightly more padding
                        fontWeight: 600    // Bolder text
                    }}
                >
                    Verify Now
                </ActionButton>
                <ResendLink
                    component="button"
                    variant="body2"
                    onClick={onResendCode}
                    sx={{
                        fontWeight: 500,
                        textDecoration: 'underline', // Add underline
                        color: 'primary.main',       // Explicitly set color
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    Resend code
                </ResendLink>
            </div>
        </StyledAlert>
    );
};

export default VerificationAlert;